export default {
  workOrders: 'Orçamentos',
  'workOrders.domain.number': 'Número',
  'workOrders.domain.company': 'Empresa',
  'workOrders.domain.customer': 'Cliente',
  'workOrders.domain.vehicle': 'Veículo',
  'workOrders.domain.vehicle.licensePlate': 'Placa',
  'workOrders.domain.vehicle.fleet': 'Frota',
  'workOrders.domain.vehicle.model': 'Modelo',
  'workOrders.domain.vehicle.brand': 'Marca',
  'workOrders.domain.vehicle.color': 'Cor',
  'workOrders.domain.complements': 'Complementos',
  'workOrders.domain.complements.number': 'Número',
  'workOrders.domain.complements.estimator': 'Orçamentista',
  'workOrders.domain.complements.customerType': 'Tipo de Cliente',
  'workOrders.domain.complements.type': 'Tipo',
  'workOrders.domain.complements.insurer': 'Seguradora',
  'workOrders.domain.complements.status': 'Status',
  'workOrders.domain.complements.accidentNumber': 'Número do Sinistro',
  'workOrders.domain.complements.insurerDeductibleAmount': 'Franquia',
  'workOrders.domain.complements.entryDate': 'Data de Entrada',
  'workOrders.domain.complements.estimatedLeaveDate': 'Data de Saída Prevista',
  'workOrders.domain.complements.authorizationDate': 'Data de Autorização',
  'workOrders.domain.complements.closingDate': 'Data de Fechamento',
  'workOrders.domain.complements.estimatedLeaveDate': 'Saída prevista',
  'workOrders.domain.complements.returnDate': 'Data de Entrega',
  'workOrders.domain.complements.prisma': 'Prisma',
  'workOrders.domain.complements.currentKilometers': 'KM de entrada',
  'workOrders.domain.complements.exitKilometers': 'KM de saída',
  'workOrders.domain.complements.tankLevel': 'Nível do Tanque',
  'workOrders.domain.complements.lastOilChange': 'Última Troca de Óleo',
  'workOrders.domain.complements.lastOilChangeKilometers':
    'Última Troca de Óleo (KM)',
  'workOrders.domain.complements.cost': 'Preço',
  'workOrders.domain.complements.customerCreate': 'Cadastro rápido de cliente',
  'workOrders.domain.complements.customerEdit': 'Edição rápida de cliente',
  'workOrders.domain.complements.vehicleCreate': 'Cadastro rápido de veículo',
  'workOrders.domain.complements.vehicleEdit': 'Edição rápida de veículo',
  'workOrders.domain.observations.observation': 'Observação',
  'workOrders.domain.observations.visibility': 'Visibilidade',

  'workOrders.domain.items.itemName': 'Descrição',
  'workOrders.domain.items.type': 'Tipo',
  'workOrders.domain.items.manufacturerCode': 'Cod. Fabricante',
  'workOrders.domain.items.manufacturingCode': 'Cod. Fabricante',
  'workOrders.domain.items.description': 'Descrição',
  'workOrders.domain.items.quantity': 'Qtd.',
  'workOrders.domain.items.quantityTime': 'Qtd./Tempo',
  'workOrders.domain.items.unitPrice': 'Preço Unit.',
  'workOrders.domain.items.unitCost': 'Custo Unitário',
  'workOrders.domain.items.totalValue': 'Valor Total',
  'workOrders.domain.items.discount': 'Desconto (%)',
  'workOrders.domain.items.discountValue': 'Desconto ($)',
  'workOrders.domain.items.partProvided': 'Peça Fornecida',
  'workOrders.domain.items.subArea': 'Sub Área',
  'workOrders.domain.items.manufacturer': 'Fabricante',
  'workOrders.domain.items.supplier': 'Fornecedor',
  'workOrders.domain.items.isPaintedPart': 'Peça Pintada',
  'workOrders.domain.items.tag': 'Tag',
  'workOrders.domain.items.status': 'Situação',
  'workOrders.domain.items.paint': 'Pintura',
  'workOrders.domain.items.timeToPaint': 'Tempo de Pintura',
  'workOrders.domain.items.repair': 'Recuperar',
  'workOrders.domain.items.timeToRepair': 'Tempo de Recuperação',
  'workOrders.domain.items.change': 'Trocar',
  'workOrders.domain.items.timeToChange': 'Tempo de Troca',

  'workOrders.domain.enums.work_order_item_status.red':
    'Item Aguardando Cotação',
  'workOrders.domain.enums.work_order_item_status.yellow': 'Item em Cotação',
  'workOrders.domain.enums.work_order_item_status.orange':
    'Item Comprado (Aguardando entrega)',
  'workOrders.domain.enums.work_order_item_status.blue': 'Item em Estoque',
  'workOrders.domain.enums.work_order_item_status.green':
    'Item em Produtividade',
  'workOrders.domain.enums.work_order_item_status.black': 'Peça digitada',

  'workOrders.domain.enums.work_order_customer_type.private': 'Particular',
  'workOrders.domain.enums.work_order_customer_type.insurance': 'Seguradora',
  'workOrders.domain.enums.work_order_type.courtesy': 'Cortesia',
  'workOrders.domain.enums.work_order_type.insideCourtesy':
    'Interna (Cortesia)',
  'workOrders.domain.enums.work_order_type.warranty': 'Garantia',
  'workOrders.domain.enums.work_order_type.work_order': 'Orçamento',
  'workOrders.domain.enums.work_order_type.total_loss': 'Perda Total',
  'workOrders.domain.enums.work_order_type.return': 'Retorno',
  'workOrders.domain.enums.work_order_type.revision': 'Revisão',
  'workOrders.domain.enums.work_order_type.porto_battery':
    'Bateria Porto (7051)',
  'workOrders.domain.enums.work_order_status.open': 'Aberta',
  'workOrders.domain.enums.work_order_status.authorized': 'Autorizado',
  'workOrders.domain.enums.work_order_status.closed': 'Fechado',
  'workOrders.domain.enums.work_order_status.cancelled': 'Cancelado',
  'workOrders.domain.enums.tank_level.full': 'Cheio',
  'workOrders.domain.enums.tank_level.seven_eights': '7/8',
  'workOrders.domain.enums.tank_level.three_quarters': '3/4',
  'workOrders.domain.enums.tank_level.half': '1/2',
  'workOrders.domain.enums.tank_level.quarter': '1/4',
  'workOrders.domain.enums.tank_level.one_eight': '1/8',
  'workOrders.domain.enums.tank_level.reserve': 'Reserva',
  'workOrders.domain.enums.tank_level.empty': 'Vazio',
  'workOrders.domain.enums.observation_visibility.customer': 'Cliente',
  'workOrders.domain.enums.observation_visibility.company': 'Oficina',
  'workOrders.domain.enums.observation_visibility.all': 'Todos',

  'workOrders.domain.enums.work_order_item_type.part': 'Peça',
  'workOrders.domain.enums.work_order_item_type.service': 'Serviço',
  'workOrders.domain.enums.work_order_item_status.pending': 'Pendente',
  'workOrders.domain.enums.work_order_item_status.done': 'Completa',
  'workOrders.domain.enums.work_order_item_status.partial': 'Parcial',

  'workOrders.create': 'Criar Novo Orçamento',
  'workOrders.create.summary': 'Resumo',
  'workOrders.create.summary.customerNotSelected':
    'Nenhum cliente foi selecionado',
  'workOrders.create.summary.vehicleNotSelected':
    'Nenhum veículo foi selecionado.',
  'workOrders.create.notifications.success.title': 'Sucesso',
  'workOrders.create.notifications.success.description': 'Orçamento criado.',

  'workOrders.details.update': 'Editar Orçamento',
  'workOrders.details.update.notifications.success.title': 'Sucesso',
  'workOrders.details.update.notifications.success.description':
    'Orçamento editado.',

  'workOrders.details.createComplement': 'Novo Complemento',

  'workOrders.details.workshopData': 'Dados da Oficina',
  'workOrders.details.clientsData': 'Dados do Cliente',
  'workOrders.details.vehicleData': 'Dados do Veículo',
  'workOrders.details.authorizedBudgetItems':
    'Histórico de itens autorizados do orçamento aberto',

  'workOrders.details.complement': 'Complemento',
  'workOrders.details.complement.info': 'Informações',
  'workOrders.details.complement.dates': 'Datas',
  'workOrders.details.complement.modal.title': 'ATENÇÃO PARA A LGPD!',
  'workOrders.details.complement.modal.description':
    'Esse cliente ainda não se posicionou a respeito da LGPD. O cliente está ciente e autoriza o uso de seus dados pela oficina?',
  'workOrders.details.complement.modal.checkbox':
    'Não mostrar este alerta novamente para este cliente.',

  'workOrders.notification.lgpd.information':
    'As configurações de lembrete e consentimentos sobre a LGPD podem ser alteradas na aba de clientes.',
  'workOrders.notification.lgpd.change.success.title':
    'Termo LGPD salvo com sucesso!',
  'workOrders.notification.lgpd.change.success.description':
    'O termo LGPD pode ser personalizado nas configurações de empresa e impresso.',

  'workOrders.details.observations': 'Observações',
  'workOrders.details.observations.empty':
    'Este orçamento ainda não tem observações',

  'workOrders.details.observations.create': 'Criar Observação',
  'workOrders.details.observations.create.notifications.success.title':
    'Sucesso',
  'workOrders.details.observations.create.notifications.success.description':
    'Observação criada.',

  'workOrders.details.observations.update': 'Editar Observação',
  'workOrders.details.observations.update.notifications.success.title':
    'Sucesso',
  'workOrders.details.observations.update.notifications.success.description':
    'Observação atualizada.',

  'workOrders.details.observations.remove.confirm.title': 'Remover observação',
  'workOrders.details.observations.remove.confirm.content':
    'Deseja realmente remover a observação selecionada?',
  'workOrders.details.observations.remove.success.message': 'Sucesso',
  'workOrders.details.observations.remove.success.description':
    'Observação removida.',

  'workOrders.details.items': 'Peças e Serviços',
  'workOrders.details.items.totalDiscountPart':
    'Valor total de desconto em peças',
  'workOrders.details.items.totalDiscountPart.invalidValue':
    'Desconto inválido.',
  'workOrders.details.items.totalDiscountService':
    'Valor total de desconto em serviços',
  'workOrders.details.items.totalDiscountService.invalidValue':
    'Desconto inválido',
  'workOrders.details.items.partTotal': 'Total de Peças',
  'workOrders.details.items.serviceTotal': 'Total de Serviços',
  'workOrders.details.items.total': 'Total Geral',

  'workOrders.details.items.changeDiscount': 'Alterar Descontos',
  'workOrders.details.items.changeDiscount.notifications.success.title':
    'Sucesso',
  'workOrders.details.items.changeDiscount.notifications.success.description':
    'Descontos atualizados.',

  'workOrders.details.items.add': 'Adicionar Item',

  'workOrders.details.items.add.select': 'Selecione',
  'workOrders.details.items.add.select.description':
    'Selecione o tipo de item a adicionar.',

  'workOrders.details.items.add.search': 'Pesquise',
  'workOrders.details.items.add.search.description':
    'Pesquise por itens para adicionar.',

  'workOrders.details.items.add.createParts': 'Cadastrar peças',
  'workOrders.details.items.add.createParts.description':
    'Cadastro de peças Fraga',

  'workOrders.details.items.add.setupItems': 'Configure',
  'workOrders.details.items.add.setupItems.description':
    'Configure a quantidade e os detalhes do item.',
  'workOrders.details.items.add.setupItems.items': 'Item',

  'workOrders.blankWorkOrder': 'Orçamento em Branco',

  'workOrders.blankChecklist': 'Checklist em Branco',

  'workOrders.importWorkOrder': 'Importar Orçamento',

  'workOrders.fieldRequiredByConfigCompany':
    'Campo marcado como obrigatório nas configurações da empresa',

  'workOrders.public.workOrder.view': 'Ordem de serviço',
};
